import * as React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";

import App from "./App";
import { store } from "./store";
import { ThemeProvider, createTheme } from "@mui/material/styles";

const container = document.getElementById("root");
if (container) {
  const theme = createTheme();
  const root = createRoot(container);
  root.render(
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </Provider>
  );
}
